export const DEMO_ACCOUNT = 'ec2-demoscenarioplanner-rbtest';
export const FILTER_FEATURES_BY = '_IMP';
